import { observer } from 'mobx-react';
import { Typography } from '@material-ui/core';
import { PropertyMethodPicker } from './propertyMethodPicker';
import { UploadedTrackRecordFile } from './uploadedTrackRecordFile';
import { AgentRunsCard } from './inProgressTable';

// observer: the uploaded-file confirmation it renders updates reactively after upload.
export const AddRecordsTab = observer(({
  classes,
  verificationStore,
  documentStore,
  borrowerId,
  onNavigate,
}: {
  classes: Record<string, string>;
  verificationStore?: any;
  documentStore?: any;
  borrowerId?: number | string;
  onNavigate?: (item: 'properties' | 'entities') => void;
}) => (
  <>
    <Typography variant="h5" className={classes.overviewTitle}>
      Add Track Record
    </Typography>
    <Typography className={classes.overviewSubtitle}>
      Upload a spreadsheet for the fastest path, or look up records we already hold.
    </Typography>
    <AgentRunsCard classes={classes} verificationStore={verificationStore} borrowerId={borrowerId} compact />
    <UploadedTrackRecordFile classes={classes} verificationStore={verificationStore} documentStore={documentStore} />
    <PropertyMethodPicker
      classes={classes}
      showRecommended
      showTemplateLink={false}
      verificationStore={verificationStore}
      borrowerId={borrowerId}
      onNavigate={onNavigate}
    />
  </>
));
